<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;My Unapproved Diary</h5>
  </div>
<div id="mainContent" class="container">
 <div class="pt-3">
    <div class="row">
      <div class="col-md-12">
        <table class="table table-bordered table-striped table-sm">
          <thead class="">
            <tr>
              <th scope="col">Week Start Date</th>
              <th scope="col">Week End Date</th>
              <th scope="col">status</th>
              <th scope="col">Diary Submitted Date</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let diary of unapproveDiaryList; index as i"
              id="branch_{{ i + 1 }}"
            >
              <td>{{ diary.weekStartDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ diary.weekEndDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ diary.status }}</td>
              <td>{{ diary.submittedDate | date: "dd-MMM-yyyy" }}</td>
            </tr>
          </tbody>
        </table>
        <!-- <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [maxSize]="1" size="sm" [pageSize]="pageSize" (pageChange)="refreshCollectionList()">
      </ngb-pagination> -->
      </div>
    </div>
  </div>
</div>
</div>